import { defaultEntityState } from '@core/state/entities/entity';
import { mergeEntityState } from '@core/state/entities/entity.helpers';
import { authApiActions } from '@core/auth/auth.actions';
import { projectDetailActions } from '@core/actions/project-detail.actions';
import { IStageUsage } from '@core/state/entities/stage-usage/stage-usage.entity';
import { createReducer, on } from '@ngrx/store';
import { entityKey } from '@core/state/entities/entity-name-map';

export const stageUsageReducer = createReducer(
  defaultEntityState<IStageUsage>(),
  on(
    projectDetailActions.projectFavouriteSet,
    projectDetailActions.stageFavouriteSet,
    authApiActions.signInRecorded,
    (state, props) => mergeEntityState(entityKey.stageUsages, state, props)
  ),
  on(projectDetailActions.loadStage, (state, props) => {
    if (state.allIds.some((stageId) => stageId === props.stageId)) {
      return state;
    } else {
      return {
        ...state,
        byId: {
          ...state.byId,
          [props.stageId]: {
            id: props.stageId,
            lastAccessed: new Date().toDateString(),
            favourite: false,
          },
        },
        allIds: [props.stageId, ...state.allIds],
      };
    }
  })
);
